export default __webpack_public_path__ + "static/media/ios-screen4.f35cb394.png";